module.exports = __webpack_public_path__ + "img/user.9e711c8c.jpeg";